import { Component } from "react"
import PropTypes from "prop-types"
import each from "lodash/each"
import find from "lodash/find"
import _map from "lodash/map"
import cloneDeep from "lodash/cloneDeep"
import isArray from "lodash/isArray"
import EndpointTestCases from "partners/components/endpoint_test/test_cases"

import * as $ from "jquery"

export default class EndpointTest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      endpoints: props.endpoints,
      status: "initial",
      containerIsExpanded: true,
    }
    this.combinedEndpointStatus = this.combinedEndpointStatus.bind(this)
    this.endpointTests = this.endpointTests.bind(this)
    this.runEndpointTest = this.runEndpointTest.bind(this)
    this.toggleContainer = this.toggleContainer.bind(this)
    this.toggleTestCase = this.toggleTestCase.bind(this)
  }

  async componentDidMount() {
    const ReactDOM = await import("react-dom/client")
    const root = ReactDOM.createRoot(
      document.getElementById("react-run-test-trigger")
    )
    root.render(this.runTestButton())
  }

  setTestCaseValue(event, key) {
    const endpoint = this.getEndpointBySlug(event.context_path[1])
    const testCase = endpoint.test_cases[event.context_path[2]]
    const newEndpoints = cloneDeep(this.state.endpoints)
    testCase[key] = event.value
    newEndpoints[endpoint.slug].test_cases[testCase.slug] = testCase
    this.setState({ endpoints: newEndpoints })
  }

  getEndpointBySlug(slug) {
    return find(this.state.endpoints, endpoint => endpoint.slug === slug)
  }

  eventCallback_assertion_failure(event) {
    this.updateAssertionFromEvent(event, { status: "failing" })
  }

  eventCallback_assertion_success(event) {
    this.updateAssertionFromEvent(event, { status: "passing" })
  }

  eventCallback_endpoint_error(event) {
    this.updateEndpointFromEvent(event, {
      status: "failing",
      message: event.message,
    })
  }

  eventCallback_endpoint_skip(event) {
    this.udpateEndpointFromEvent(event, {
      status: "passing",
      message: event.message,
    })
  }

  eventCallback_suite_end() {
    this.complete()
  }

  eventCallback_test_case_error(event) {
    this.updateTestCaseFromEvent(event, {
      status: "failing",
      message: event.message,
    })
  }

  eventCallback_test_case_request(event) {
    this.setTestCaseValue(event, "request")
  }

  eventCallback_test_case_response(event) {
    this.setTestCaseValue(event, "response")
  }

  eventCallback_test_case_skip(event) {
    this.updateTestCaseFromEvent(event, {
      status: "passing",
      message: event.message,
    })
  }

  runEndpointTest(event) {
    event.preventDefault()
    this.setState({
      status: "working",
      lastEventIndex: 0,
      endpoints: this.props.endpoints,
    })
    $.ajax({
      type: "POST",
      url:
        this.props.session_path +
        "?authenticity_token=" +
        window.encodeURIComponent(this.props.authenticity_token),
      dataType: "json",
    }).done(sessionData => {
      this.sessionId = sessionData.session_id
      this.checkForEvents()
    })
  }

  endpointTests() {
    return _map(this.state.endpoints, endpoint => {
      const status = this.endpointStatus(endpoint)
      let text = ` ${endpoint.label}`
      if (endpoint.message) {
        text += `: ${endpoint.message}`
      }
      return (
        <div
          key={endpoint.dom_id}
          className={`endpoint publish-item ${status} ${
            endpoint.isShowing ? "expanded" : "collapsed"
          }`}
        >
          <header onClick={() => this.toggleEndpoint(endpoint)}>{text}</header>
          {endpoint.isShowing ? (
            <EndpointTestCases
              endpoint={endpoint}
              testCaseStatus={this.testCaseStatus}
              toggleTestCase={this.toggleTestCase}
            />
          ) : null}
        </div>
      )
    })
  }

  testCaseStatus(testCase) {
    if (testCase.status) {
      return testCase.status
    }
    let status
    each(testCase.assertions, assertion => {
      if (assertion.status === "undefined") {
        status = "neutral"
        return false
      } else if (assertion.status === "failing") {
        status = "failing"
        return false
      } else {
        status = assertion.status
      }
    })
    return status
  }

  endpointStatus(endpoint) {
    if (endpoint.status) {
      return endpoint.status
    }
    let status = "passing"
    each(endpoint.test_cases, testCase => {
      status = this.testCaseStatus(testCase)
      if (status === "failing" || status === "neutral") return false
    })
    return status
  }

  complete(errorMessage) {
    this.setState({ status: "completed", errorMessage })
    this.stopTimeout()
  }

  combinedEndpointStatus() {
    if (this.state.status !== "completed") {
      return ""
    }
    if (typeof this.state.errorMessage !== "undefined") {
      return "failing"
    }
    let status
    each(this.state.endpoints, endpoint => {
      status = this.endpointStatus(endpoint)
      if (status === "failing") {
        return false
      }
    })
    return status
  }

  checkForEvents() {
    if (this.state.status === "completed") {
      return
    }
    $.ajax({
      type: "GET",
      url: this.props.test_results_path,
      data: {
        offset: this.state.lastEventIndex,
        session_id: this.sessionId,
      },
      dataType: "json",
      cache: false,
    })
      .done(events => {
        if (isArray(events) && events.length) {
          this.startTimeout()
          let suiteEndFound = false
          let index = 0
          each(events, event => {
            if (event.type === "suite_end") {
              suiteEndFound = true
            }
            this[`eventCallback_${event.type}`](event)
            index = event.index
          })
          if (!suiteEndFound) {
            this.setState({ lastEventIndex: index - 1 })
            this.checkForEvents()
          }
        } else {
          this.checkForEvents()
        }
      })
      .fail(response => {
        if (response.status === 404) {
          this.timeoutError()
        } else {
          this.complete("Error communicating with server.")
        }
      })
  }

  statusText() {
    const status = this.combinedEndpointStatus()
    let statusText =
      this.state.status === "initial" ? "Not running" : "Running tests…"
    if (status === "passing") {
      statusText = "Success! All endpoint tests passed."
    } else if (status === "failing") {
      statusText = "Endpoint tests failed."
      if (this.state.errorMessage) {
        statusText += `: ${this.state.errorMessage}`
      }
    }
    return ` ${statusText}`
  }

  startTimeout() {
    this.stopTimeout()
    this.timeout = setTimeout(() => {
      this.timeoutError()
    }, 35000)
  }

  stopTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      delete this.timeout
    }
  }

  timeoutError() {
    this.complete("Error - test timeout exceeded.")
  }

  toggleEndpoint(endpoint) {
    let _endpoint = endpoint
    const endpoints = cloneDeep(this.state.endpoints)
    _endpoint.isShowing = !_endpoint.isShowing
    endpoints[_endpoint.slug] = _endpoint
    this.setState({ endpoints })
  }

  toggleContainer() {
    this.setState({ containerIsExpanded: !this.state.containerIsExpanded })
  }

  toggleTestCase(testCase) {
    let _testCase = testCase
    const endpoints = cloneDeep(this.state.endpoints)
    _testCase.isShowing = !_testCase.isShowing
    endpoints[_testCase.endpoint_slug].test_cases[_testCase.slug] = _testCase
    this.setState({ endpoints })
  }

  updateEndpointFromEvent(event, options) {
    const endpoint = this.getEndpointBySlug(event.context_path[1])
    const endpoints = cloneDeep(this.state.endpoints)
    each(options, (value, key) => {
      endpoint[key] = value
    })
    endpoints[endpoint.slug] = endpoint
    this.setState({ endpoints })
  }

  updateTestCaseFromEvent(event, options) {
    const endpoint = this.getEndpointBySlug(event.context_path[1])
    const testCase = endpoint.test_cases[event.context_path[2]]
    const endpoints = cloneDeep(this.state.endpoints)
    each(options, (value, key) => {
      testCase[key] = value
    })
    endpoints[endpoint.slug].test_cases[testCase.slug] = testCase
    this.setState({ endpoints })
  }

  updateAssertionFromEvent(event, options) {
    const endpoint = this.getEndpointBySlug(event.context_path[1])
    const testCase = endpoint.test_cases[event.context_path[2]]
    const assertion = testCase.assertions[event.context_path[3]]
    const endpoints = cloneDeep(this.state.endpoints)
    each(options, (value, key) => {
      assertion[key] = value
    })
    endpoints[endpoint.slug].test_cases[testCase.slug].assertions[
      assertion.slug
    ] = assertion
    this.setState({ endpoints })
  }

  runTestButton() {
    return (
      <a
        role="button"
        className="button-tertiary"
        onClick={this.runEndpointTest}
      >
        Begin test
      </a>
    )
  }

  render() {
    const endpointTests = this.state.containerIsExpanded
      ? this.endpointTests()
      : null
    const statusText = this.statusText()
    const cssClass = this.combinedEndpointStatus()
    return (
      <article className={`publish-item heading ${cssClass}`}>
        <header>{statusText}</header>
        {endpointTests}
      </article>
    )
  }
}

EndpointTest.propTypes = {
  test_results_path: PropTypes.string.isRequired,
  authenticity_token: PropTypes.string.isRequired,
  endpoints: PropTypes.object.isRequired,
  session_path: PropTypes.string.isRequired,
}
